/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {CallInvoices} from '../model/callInvoices';
import {SearchInvoicePrepareDataVO} from '../model/searchInvoicePrepareDataVO';
import {CallInvoicesDTO} from '../model/callInvoicesDTO';
import {CallInvoiceIncident} from '../model/callInvoiceIncident';
import {CallInvoicePartnerConfigurationDto} from '../model/callInvoicePartnerConfigurationDto';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class ConfiguratorCallInvoicesService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    public getIncidents(tenant: string, callInvoiceId?: string): Observable<CallInvoiceIncident[]> {
        const params = callInvoiceId ? new HttpParams().set('callInvoiceId', callInvoiceId) : new HttpParams();
        return this.httpClient.get<CallInvoiceIncident[]>(`${this.basePath}/api/callInvoices/incidents`, {
            headers: this.defaultHeaders.set('X-DataStoreID', tenant), params, withCredentials: this.configuration.withCredentials
        });
    }

    public retryIncident(tenant: string, callId: string, incidentId: string): Observable<CallInvoiceIncident> {
        return this.httpClient.post<CallInvoiceIncident>(`${this.basePath}/api/callInvoices/${encodeURIComponent(callId)}/incidents/${encodeURIComponent(incidentId)}/retry`, null, {
            headers: this.defaultHeaders.set('X-DataStoreID', tenant), withCredentials: this.configuration.withCredentials
        });
    }

    public saveConfiguration(tenant: string, configuration: SearchInvoicePrepareDataVO): Observable<CallInvoicesDTO> {
        return this.httpClient.put<CallInvoicesDTO>(`${this.basePath}/api/callInvoices/configuration`, configuration, {
            headers: this.defaultHeaders.set('X-DataStoreID', tenant), withCredentials: this.configuration.withCredentials
        });
    }

    public getDeliveryMode(tenant: string): Observable<{mode: 'SMTP' | 'BREVO' | 'UNAVAILABLE'}> {
        return this.httpClient.get<{mode: 'SMTP' | 'BREVO' | 'UNAVAILABLE'}>(`${this.basePath}/api/callInvoices/delivery-mode`, {
            headers: this.defaultHeaders.set('X-DataStoreID', tenant), withCredentials: this.configuration.withCredentials
        });
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /** Vérifier les fiches clientes et contacts de facturation des partenaires sélectionnés. */
    public getPartnerConfigurationStatusUsingGET(xDataStoreID: string, partnerCodes: string[], observe?: 'body', reportProgress?: boolean): Observable<CallInvoicePartnerConfigurationDto[]>;
    public getPartnerConfigurationStatusUsingGET(xDataStoreID: string, partnerCodes: string[], observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CallInvoicePartnerConfigurationDto[]>>;
    public getPartnerConfigurationStatusUsingGET(xDataStoreID: string, partnerCodes: string[], observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CallInvoicePartnerConfigurationDto[]>>;
    public getPartnerConfigurationStatusUsingGET(xDataStoreID: string, partnerCodes: string[], observe: any = 'body', reportProgress = false): Observable<any> {
        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getPartnerConfigurationStatusUsingGET.');
        }
        if (partnerCodes === null || partnerCodes === undefined) {
            throw new Error('Required parameter partnerCodes was null or undefined when calling getPartnerConfigurationStatusUsingGET.');
        }

        const headers = this.defaultHeaders.set('X-DataStoreID', String(xDataStoreID)).set('Accept', 'application/json');
        let params = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        partnerCodes.forEach(code => params = params.append('partnerCodes', code));
        return this.httpClient.get<CallInvoicePartnerConfigurationDto[]>(
            `${this.basePath}/api/callInvoices/partner-configuration`,
            { withCredentials: this.configuration.withCredentials, headers, params, observe, reportProgress }
        );
    }

    /** Vérifier la présence de la clé Brevo du partenaire principal du tenant. */
    public getBrevoConfigurationStatusUsingGET(xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public getBrevoConfigurationStatusUsingGET(xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public getBrevoConfigurationStatusUsingGET(xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public getBrevoConfigurationStatusUsingGET(xDataStoreID: string, observe: any = 'body', reportProgress = false): Observable<any> {
        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getBrevoConfigurationStatusUsingGET.');
        }

        const headers = this.defaultHeaders.set('X-DataStoreID', String(xDataStoreID)).set('Accept', 'application/json');
        return this.httpClient.get<boolean>(
            `${this.basePath}/api/callInvoices/brevo-configured`,
            { withCredentials: this.configuration.withCredentials, headers, observe, reportProgress }
        );
    }

    /** Vérifier si datastore.s3Settings est complet pour les appels à facturation. */
    public getS3ConfigurationStatusUsingGET(xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public getS3ConfigurationStatusUsingGET(xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public getS3ConfigurationStatusUsingGET(xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public getS3ConfigurationStatusUsingGET(xDataStoreID: string, observe: any = 'body', reportProgress = false): Observable<any> {
        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getS3ConfigurationStatusUsingGET.');
        }

        const headers = this.defaultHeaders.set('X-DataStoreID', String(xDataStoreID)).set('Accept', 'application/json');
        return this.httpClient.get<boolean>(
            `${this.basePath}/api/callInvoices/s3-configured`,
            { withCredentials: this.configuration.withCredentials, headers, observe, reportProgress }
        );
    }

    /**
     * Créer un appel à facturation
     * Cette requête permet de créer un appel à facturation qui permet de renseigner les clients par l&#39;état de leurs commandes.&lt;br&gt;La requête renvoie le code 201 (Created) si l&#39;appel est bien pris en compte.&lt;br&gt;La requête renvoie le code 400 (Bad Request) si l&#39;appel à facturation a déjà un identifiant.
     * @param xDataStoreID X-DataStoreID
     * @param callInvoices callInvoices
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createCallInvoicesUsingPOST(xDataStoreID: string, callInvoices: CallInvoices, observe?: 'body', reportProgress?: boolean): Observable<CallInvoices>;
    public createCallInvoicesUsingPOST(xDataStoreID: string, callInvoices: CallInvoices, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CallInvoices>>;
    public createCallInvoicesUsingPOST(xDataStoreID: string, callInvoices: CallInvoices, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CallInvoices>>;
    public createCallInvoicesUsingPOST(xDataStoreID: string, callInvoices: CallInvoices, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling createCallInvoicesUsingPOST.');
        }

        if (callInvoices === null || callInvoices === undefined) {
            throw new Error('Required parameter callInvoices was null or undefined when calling createCallInvoicesUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<CallInvoices>(`${this.basePath}/api/callInvoices`,
            callInvoices,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Supprimer un appel à facturation par son identifiant
     * Cette requête permet de supprimer un appel à facturation par son identifiant&lt;br&gt;La requête renvoie le code 204 (NO_CONTENT) si l&#39;appel à facturation est bien supprimé.
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteCallInvoicesUsingDELETE(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteCallInvoicesUsingDELETE(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteCallInvoicesUsingDELETE(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteCallInvoicesUsingDELETE(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling deleteCallInvoicesUsingDELETE.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteCallInvoicesUsingDELETE.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/callInvoices/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lister tous les appels à facturation
     * Cette requête permet de lister tous les appels à facturation&lt;br&gt;La requête renvoie le code 200 (OK) si les appels à facturation sont bien lus.
     * @param xDataStoreID X-DataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllCallInvoicessUsingGET(xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CallInvoicesDTO>>;
    public getAllCallInvoicessUsingGET(xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CallInvoicesDTO>>>;
    public getAllCallInvoicessUsingGET(xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CallInvoicesDTO>>>;
    public getAllCallInvoicessUsingGET(xDataStoreID: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getAllCallInvoicessUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<CallInvoicesDTO>>(`${this.basePath}/api/callInvoices`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtenir un appel à facturation par son identifiant
     * Cette requête permet d&#39;obtenir un appel à facturation par son identifiant&lt;br&gt;La requête renvoie le code 200 (OK) si l&#39;appel à facturation est bien lu.&lt;br&gt;La requête renvoie le code 404 (Not Found) si l&#39;appel à facturation n&#39;est pas trouvé.&lt;br&gt;&lt;b&gt; Note : &lt;/b&gt; Le paramètre &lt;b&gt;full-data&lt;/b&gt; est toujours sous développement.
     * @param xDataStoreID X-DataStoreID
     * @param fullData full-data
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCallInvoicesUsingGET(xDataStoreID: string, fullData: boolean, id: string, observe?: 'body', reportProgress?: boolean): Observable<CallInvoicesDTO>;
    public getCallInvoicesUsingGET(xDataStoreID: string, fullData: boolean, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CallInvoicesDTO>>;
    public getCallInvoicesUsingGET(xDataStoreID: string, fullData: boolean, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CallInvoicesDTO>>;
    public getCallInvoicesUsingGET(xDataStoreID: string, fullData: boolean, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getCallInvoicesUsingGET.');
        }

        if (fullData === null || fullData === undefined) {
            throw new Error('Required parameter fullData was null or undefined when calling getCallInvoicesUsingGET.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getCallInvoicesUsingGET.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (fullData !== undefined && fullData !== null) {
            queryParameters = queryParameters.set('full-data', <any> fullData);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<CallInvoicesDTO>(`${this.basePath}/api/callInvoices/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mettre à jour un appel à facturation
     * Cette requête permet de mettre à jour un appel à facturation&lt;br&gt;La requête renvoie le code 200 (OK) si l&#39;appel à facturation est bien mis à jour.&lt;br&gt;La requête renvoie le code 400 (Bad Request) si l&#39;appel à facturation n&#39;est pas valide.&lt;br&gt;La requête renvoie le code 500 (Internal Server Error) si l&#39;appel à facturation n&#39;a pas pu être mis à jour.
     * @param xDataStoreID X-DataStoreID
     * @param callInvoices callInvoices
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateCallInvoicesUsingPUT(xDataStoreID: string, callInvoices: CallInvoices, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateCallInvoicesUsingPUT(xDataStoreID: string, callInvoices: CallInvoices, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateCallInvoicesUsingPUT(xDataStoreID: string, callInvoices: CallInvoices, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateCallInvoicesUsingPUT(xDataStoreID: string, callInvoices: CallInvoices, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateCallInvoicesUsingPUT.');
        }

        if (callInvoices === null || callInvoices === undefined) {
            throw new Error('Required parameter callInvoices was null or undefined when calling updateCallInvoicesUsingPUT.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/api/callInvoices`,
            callInvoices,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mettre à jour le template de mail
     * Cette requête permet de mettre à jour le template de mail de sendInBlue&lt;br&gt;La requête renvoie le code 200 (OK) si l&#39;appel à facturation est bien mis à jour.&lt;br&gt;La requête renvoie le code 400 (Bad Request) si l&#39;appel à facturation n&#39;est pas valide.&lt;br&gt;La requête renvoie le code 500 (Internal Server Error) si l&#39;appel à facturation n&#39;a pas pu être mis à jour.
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param templateSib templateSib
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateTemplateUsingPUT(xDataStoreID: string, id: string, templateSib: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateTemplateUsingPUT(xDataStoreID: string, id: string, templateSib: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateTemplateUsingPUT(xDataStoreID: string, id: string, templateSib: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateTemplateUsingPUT(xDataStoreID: string, id: string, templateSib: number, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateTemplateUsingPUT.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateTemplateUsingPUT.');
        }

        if (templateSib === null || templateSib === undefined) {
            throw new Error('Required parameter templateSib was null or undefined when calling updateTemplateUsingPUT.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<any>(`${this.basePath}/api/callInvoices/${encodeURIComponent(String(id))}/${encodeURIComponent(String(templateSib))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
